'use client';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import Prev from '@/components/common/ui/buttons/Prev';
import Next from '@/components/common/ui/buttons/Next';

const BlogList = ({ data, title }) => {
	const nextRef = useRef()
	const prevRef = useRef()
	const section_data = data?.section_data;
	const image_data = data?.images?.list || data?.images;
	const bannerimage = image_data?.list;

	return (
		<StyledBlogList className="">
			<Swiper
				Swiper modules={[Autoplay, Pagination, Navigation]}
				allowTouchMove={true}
				autoHeight={true}
				slidesPerView={1}
				effect={'fade'}
				speed={800}
				navigation={{
					prevEl: '.prev_swipper',
					nextEl: '.next_swipper',
				}}
				loop={true}
			>
				{
					data?.images?.list && data?.images?.list?.length > 0 &&
					data?.images?.list?.map((e, index) => {
						return (
							<SwiperSlide key={index}>
								<div className="image-blog-wrapper">
									<img src={e?.full_path} alt={e?.short_title || ''} />
								</div>
								<div className="caption">
									<p>{e?.short_title}</p>
								</div>
							</SwiperSlide>
						);
					})
				}

				{
					data?.images && data?.images?.length > 0 &&
					data?.images?.map((e, index) => {
						return (
							<SwiperSlide key={index}>
								<div className="image-blog-wrapper">
									<img src={e?.full_path} alt={e?.short_title || ''} />
								</div>
								<div className="caption">
									<p>{e?.short_title}</p>
								</div>
							</SwiperSlide>
						);
					})
				}
			</Swiper>
			<ul className={'navigation_item'}>
				<li className={'prev_swipper'} ref={prevRef}>
					<Prev background={'#152637'} color={'white'} />
				</li>
				<li className={'next_swipper'} ref={nextRef}>
					<Next background={'#152637'} color={'white'} />
				</li>
			</ul>
		</StyledBlogList>
	);
};

const StyledBlogList = styled.div`

    position: relative;

    .navigation_item {
		display: flex;
		position: absolute;
		right: 0;
		bottom: -68px;
		gap: 15px;
		z-index: 9;
		li{
			list-style: none;
		}
    }

    .image-flex {
        display: flex;
        gap: 30px;
        flex-wrap: nowrap;
        margin-bottom: 60px;

        .single-image_date {
            flex: 0 0 calc(50% - 30px);
            max-width: calc(50% - 30px);
        }
    }

    h3 {
        margin-bottom: 20px;
    }

    p {
        font-weight: 400;
        font-size: 1rem; /* 16px */
        line-height: 1.5rem; /* 24px */
        letter-spacing: 0;
        margin-bottom: 20px;

        span {
            color: #DD223F;
        }
    }

    .image-blog-wrapper {
        margin-top: 40px;
        margin-bottom: 40px;
        padding-top: calc(430 / 770 * 100%) !important;

		position: relative;
		
        img {
            width: 100%;
            height: auto;
            border-radius: 10px;
			position: absolute;
			inset: 0;
			height: 100%;
			width: 100%;
			object-fit: cover;
        }

        p {
            margin-top: 20px;
            font-weight: 500;
        }
    }

    .video_single {
        margin: 0 0 60px;

        .video-box {
            padding-top: calc(430 / 770 * 100%) !important;
        }
    }

    blockquote {
        padding: 18px 25px;
        opacity: 0.92;
        background: rgba(150, 125, 62, 0.28);
        color: #886C37;
        font-size: 0.9rem;
        font-style: normal;
        font-weight: 300;
        line-height: 1.377rem;
        letter-spacing: -0.027rem;
        margin: 60px 0;
    }


    .round-list {
        margin-top: 40px;
        list-style: none;

        li {
            border-bottom: 1px solid rgba(21, 38, 55, 0.2);
            padding-bottom: 10px;
            margin-bottom: 10px;
            color: #152637;
            font-weight: 400;
            font-size: 1rem; /* 16px */
            line-height: 1.5rem; /* 24px */
            letter-spacing: 0em; /* 0% */
            position: relative;
            counter-increment: count;
            padding-left: 32px;
            list-style: none;

            h3 {
                font-weight: 500;
                font-size: 1.25rem; /* 20px */
                line-height: 1.5rem; /* 24px */
                letter-spacing: 0;
                margin-bottom: 10px;
            }

            p {
                margin: 0;
            }

            &:before {
                width: 20px;
                height: 20px;
                background: #DD223F;
                content: counter(count, decimal);
                font-weight: 400;
                font-size: 0.625rem; /* 10px */
                line-height: 0.75rem; /* 12px */
                letter-spacing: 0;
                text-align: center;
                position: absolute;
                color: white;
                left: 0;
                top: 5px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
    li::marker {
        color: #DD223F;
    }
    ul {
        list-style: disc;
        padding-left: 15px;
        margin-bottom: 60px;

        li {
            list-style: disc;
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.53rem;
            letter-spacing: -0.023rem;
            margin-bottom: 10px;

            &::marker {
                color: #DD223F;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    table {
        width: 100%;
        border-collapse: collapse;
        font-weight: 400;
        font-size: 1rem; /* 16px */
        line-height: 1.5rem; /* 24px */
        letter-spacing: 0;
        color: #394149;
        margin-bottom: 60px;
    }

    tr {
        display: flex;
    }

    th, td {
        width: 50%; /* Each cell takes 50% */
        border-bottom: 1px solid rgba(21, 38, 55, 0.2); /* Light gray border */
        padding: 20px 0 20px;
        text-align: left;
    }

    th {
        font-weight: 700;
        padding-top: 0;
        border-bottom: 1px solid #152637; /* Light gray border */

    }

    tr:nth-child(even) {
    }

    tr:hover {
    }

    .caption {
		min-height: 25px;
    }


`;


export default BlogList;
